import axios from 'axios'
import {
  PAYMENT_METHOD_CARD_NAME,
} from '@/constants/plans'
import { mapGetters } from 'vuex'


let count = 0
export default {
  computed: {
    ...mapGetters({
      paymentsMethodsList: 'plans/paymentMethods',
    })
  },

  async mounted () {
    await this.setUserGeo()
  },

  methods: {
    async setUserGeo () {
      const res = await this.$store.dispatch('main/getUserGeolocation')
      const countryCode = res?.country_code

      // если не удалось получить страну, то пробуем еще 1 раз
      if (!countryCode && count < 1) {
        count ++
        await this.setUserGeo()
        return
      }

      if (countryCode) {
        this.setPaymentProvider(countryCode)
      }
    },

    setPaymentProvider (countryCode) {
      const paymentMethods = this.paymentsMethodsList

      if (countryCode === 'RU') {
        //в константах src/constants/plans.js есть переменная paymentMethods
        //у которого уже есть paymentMethods[0] = PAYMENT_METHOD_UNLIMINT_NAME
        paymentMethods[0] = PAYMENT_METHOD_CARD_NAME
      }

      this.$store.dispatch('plans/setPaymentMethods', paymentMethods);
    }
  }
}
